// /src/services/orderStatsApi.js

// Helper to normalise city string
function normalizeCity(value = "") {
  return String(value).trim().toLowerCase();
}

export function calculateOrderStats(orders = []) {
  // Base structure for each bucket
  const baseBucket = () => ({ total: 0, cork: 0, limerick: 0 });

  const stats = {
    current_orders: baseBucket(),
    vendor_accepted: baseBucket(),
    vendor_pending: baseBucket(),
    driver_accepted: baseBucket(),
    driver_pending: baseBucket(),
    rejected: baseBucket(),     
    total_revenue: 0,            // ✅ USED BY "Total Revenue" CARD
  };

  orders.forEach((order) => {
    // ====== CITY DETECTION (Cork / Limerick) ======
    // Try to read city from venue/company or customer address, then fall back.
    const cityRaw =
      order?.venue?.company?.town ||
      order?.venue?.company?.title || // often contains "Cork" / "Limerick"
      order?.data?.customer_address?.city ||
      order?.data?.customer_address?.address ||
      order.city ||
      order.city_name ||
      order.customer_city ||
      order.customerCity ||
      "";

    const city = normalizeCity(cityRaw);
    const isCork = city.includes("cork");
    const isLimerick = city.includes("limerick");

    const inc = (bucket) => {
      bucket.total += 1;
      if (isCork) bucket.cork += 1;
      if (isLimerick) bucket.limerick += 1;
    };

    // ====== TOTAL REVENUE ======
    // Uses the "TOTAL" column you see in the table: order.payment.total
    const orderTotal = Number(order?.payment?.total) || 0;
    stats.total_revenue += orderTotal;

    // ====== STATUSES (matching your OverviewTable) ======
    // STATUS column: order.status -> 'accepted', 'pending', 'looking_for_driver', 'rejected'
    const status = String(order?.status || "").toLowerCase();

    // DELIVERY column: order.delivery_status -> 'delivered', 'pending',
    // 'failed', 'returned', 'out_for_delivery'
    const deliveryStatus = String(order?.delivery_status || "").toLowerCase();

    // 👉 Current orders = not completed / not failed / not returned
    if (
      deliveryStatus !== "delivered" &&
      deliveryStatus !== "returned" &&
      deliveryStatus !== "failed"
    ) {
      inc(stats.current_orders);
    }

    // 👉 Vendor Accepted / Pending (based on STATUS)
    if (status === "accepted") {
      inc(stats.vendor_accepted);
    } else if (status === "pending" || status === "looking_for_driver") {
      inc(stats.vendor_pending);
    }

    // 👉 Driver Accepted / Pending (based on DELIVERY + STATUS)
    // You can tweak these rules to whatever your mentor wants.
    if (deliveryStatus === "out_for_delivery" && status === "accepted") {
      inc(stats.driver_accepted);
    } else if (deliveryStatus === "pending" && status === "accepted") {
      inc(stats.driver_pending);
    }

    // ✅ Rejected
    if (status === "rejected") {
      inc(stats.rejected);
    }

  });

  return stats;
}
